import useSearchParamGroup from "ui/common/hooks/useSearchParamGroup";
import { SendState, SendStateNames } from "ui/transactions/transactions.types";

export default function useSendQueryParams(): Partial<SendState> {
    function validateAmount(value: string) {
        const amount = Number(value);
        return !isNaN(amount) && amount >= 0;
    }

    const [{ destinationAddress, concept, amount, paymentId, reference }] = useSearchParamGroup(
        SendStateNames.DESTINATION_ADDRESS,
        SendStateNames.CONCEPT,
        SendStateNames.PAYMENT_ID,
        SendStateNames.REFERENCE,
        [SendStateNames.AMOUNT, { validation: validateAmount }],
    );

    return {
        destinationAddress,
        concept,
        amount,
        paymentId,
        reference,
    };
}
